import { useQuery } from '@tanstack/react-query'
import { useSpacesApi } from '../spaces-api'

export interface LdFlagsData {
  isLoading: boolean
  isError: boolean
  isReloading: boolean
  error?: unknown
  flags?: Record<string, any>
}

export function buildLdQueryKey(): string[] {
  return ['ld-flags']
}

export const useLDFlags = (): LdFlagsData => {
  const { spacesApi } = useSpacesApi()
  const query = useQuery<Map<string, string>>(
    buildLdQueryKey(),
    async () => {
      const response = await spacesApi.get(`/launchdarkly`)
      return response.data
    },
    {
      retryDelay: 500,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  )

  return {
    isLoading: query.isLoading,
    isReloading: query.isRefetching && query.isStale,
    isError: query.isError,
    error: query.error,
    flags: query.data,
  }
}
